/**
 * Input Schema of TipoPessoaRecebedor
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {TipoPessoaRecebedor} from '@/model/resource/TipoPessoaRecebedor'

/* TODO: review generated schema */
export class InputTipoPessoaRecebedorSchema extends Schema {
  readonly name = 'InputTipoPessoaRecebedor'

  readonly fieldSet: FieldSet<TipoPessoaRecebedor> = {
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
